
import React from 'react';
import { Box, Card, Divider, TableBody, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Sample from "../../AdminDashboard/Onsite And Offsite/Sample.json";
import IconButton from '@mui/material/IconButton';
import Edit from "../../../icons/edit.svg";
import Trash from "../../../icons/trash1.svg";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useState, useEffect } from 'react';
import { MenuItem, Tooltip } from "@mui/material";
import Select from "@mui/material/Select";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import axios from '../../../utils/fvAxios';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Nodata from "../../Nodata/Nodata";
import Paginator from '../../../toolkit/Paginator';
import { ToastContainer, toast } from "react-toastify";
import { HasPermissions } from '../../../utils/Token';
import INFO from '../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../utils/Enums.json";


export default function InvitationConfiguration() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.action.hover,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
            marginBottom: "20px"
        },
    }));
    const toastNotify = (message, isSuccess = true) => {
        if (isSuccess) {
            toast.success(message, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        } else {
            toast.error(message, {
                position: "top-right",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
            });
        }
    };
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: 200,
            },
        },
    };
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

    const Invitationlist = [
        {
            key: "-1",
            name: "All"
        }, {
            key: "0",
            name: "New Invitation"
        }, {
            key: "1",
            name: "Expired Invitation"
        }, {
            key: "2",
            name: "Outside Invitation"
        },
    ]


    const [open, setOpen] = useState(false);
    const [Tab, setTab] = useState("");
    const [id, setID] = useState("");
    const [ClientEmailTemplates, setClientEmailTemplates] = React.useState([]);
    const [Count, setCount] = useState("");
    const [number, setNumber] = useState("1");
    const [Search, setSearch] = useState("");
    const [spinner, setSpinner] = React.useState(false);
    const [ClientList, setClientList] = React.useState([]);
    const [clientId, setClientId] = React.useState("");
    const [EmailList, setEmailList] = React.useState([]);
    const [emailId, setEmailId] = React.useState("");
    const [invitationTypeId, setInvitationTypeId] = React.useState("");
    const [RisklevelList, setRisklevelList] = React.useState([]);
    const [RisklevelId, setRisklevelId] = React.useState("");

    const [Dis, setDis] = React.useState(false);

    useEffect(() => {
        GetClientEmailTemplates("");
    }, [Search, number]);
    useEffect(() => {
        Details();
    }, []);
    async function GetClientEmailTemplates(num) {
        const val = num != "" ? num : number;
        setSpinner(true);
        const res = await axios.get("SystemUser/GetClientEmailTemplates?pageSize=" + 12 + "&pageNumber=" + val + "&filters=" + Search);
        setClientEmailTemplates(res?.data?.data);
        setCount(res?.data?.count);
        setSpinner(false);
    }
    async function Details() {
        const res = await axios.get("Prequalification/GetAllClients?getAll=false&isIncludeMultiClient=false");
        setClientList(res?.data?.data);
        const resp = await axios.get("EmailTemplates/GetEmailTemplatesList");
        setEmailList(resp?.data?.data?.localEmailTemplateListObj);
    }


    const OpenTab = (num, p) => {
        setTab(num);
        ChangeClient(num == 2 ? p?.clientId : "");
        setEmailId(num == 2 ? p?.emailTemplateId : "");
        setInvitationTypeId(num == 2 ? p?.invitationType + "" : "");
        setRisklevelId(num == 2 ? p?.clientTemplateId : "");
        setID(num == 2 || num == 3 ? p?.id : "");
        setOpen(true);
    };

    const ChangeClient = async (val) => {
        setClientId(val);
        setRisklevelId("");
        const resp = await axios.get("Common/GetRiskLevelWithDetailsByClientId?clientId=" + val);
        setRisklevelList(resp?.data?.data);

    }

    const CloseTab = () => {
        setOpen(false);
    };
    const SpinnerClose = () => {
        setSpinner(false);
    };
    const FreeSearch = (e) => {
        setSearch(e);
        setNumber("1");
    }
    const handlePageChange = (event) => {
        setNumber(event);
    };
    const AddorUpdate = async () => {
        if (Tab == 1 || Tab == 2) {
            setDis(true);
            if (clientId != "" && emailId != "" && invitationTypeId != "" && RisklevelId != "") {
                const data = {
                    "id": Number(id),
                    "clientId": clientId,
                    "invitationType": invitationTypeId,
                    "templateId": emailId,
                    "questionnaireTemplateId": RisklevelId
                }
                const res = await axios.post("SystemUser/AddOrEditInvitationConfigration", data);
                if (res?.data?.responseCode == 100) {
                    toastNotify(res?.data?.data, true);
                    // handlePageChange(1);
                    CloseTab();
                    setDis(false);
                    GetClientEmailTemplates(1);

                } else {
                    toastNotify(res?.data?.responseMessage, false);
                    setDis(false);
                }
            } else {
                toastNotify("Please enter mandatory fields", false);
                setDis(false);
            }
        } else {
            const res = await axios.post("SystemUser/DeleteInvitationConfigration?id=" + id);
            if (res?.data?.responseCode == 100) {
                toastNotify(res?.data?.responseMessage, true);
                // handlePageChange(1);
                CloseTab();
                GetClientEmailTemplates(1);
            } else {
                toastNotify(res?.data?.responseMessage, false);
            }

        }
    }


    return (
        <>
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Dialog fullScreen={fullScreen} open={open} onClose={CloseTab}>
                <DialogContent sx={{ padding: "48px 48px" }}>
                    <DialogTitle
                        sx={{
                            textAlign: "center",
                            fontWeight: 500,
                            fontSize: 20,
                        }}
                    >
                        <span style={{ fontSize: "larger" }} >{Tab == 3 ? "Delete  Invitation Configuration " : Tab == 1 ? " Add  Invitation Configuration  " : " Edit Invitation Configuration  "}</span>
                    </DialogTitle>

                    <DialogActions >
                        <div className='mx-2'>
                            {Tab == 3 ? " Do you want to delete this Invitation Configuration ?" : <>
                                <div >
                                    <span style={{ color: "#3E4A62" }}> Client  <span style={{ color: "red" }}>*</span></span>
                                    <br />
                                    <Select
                                        sx={{
                                            '& legend': { display: 'none' },
                                            '& fieldset': { top: 0 },
                                            width: "320px"
                                        }}
                                        labelId="demo-multiple-name-label"
                                        value={clientId || ""}
                                        id="demo-multiple-name"
                                        size="small"
                                        onChange={(e) => ChangeClient(e.target.value)}
                                        MenuProps={MenuProps}
                                    >
                                        {ClientList?.map((r, i) =>
                                            <MenuItem key={i} title={r?.text} value={r?.value} > {r?.text}</MenuItem>
                                        )}
                                    </Select>

                                </div>
                                <div >
                                    <span style={{ color: "#3E4A62" }}> Risk level  <span style={{ color: "red" }}>*</span></span>
                                    <br />
                                    <Select
                                        sx={{
                                            '& legend': { display: 'none' },
                                            '& fieldset': { top: 0 },
                                            width: "320px"
                                        }}
                                        labelId="demo-multiple-name-label"
                                        value={RisklevelId || ""}
                                        id="demo-multiple-name"
                                        size="small"
                                        onChange={(e) => setRisklevelId(e.target.value)}
                                        MenuProps={MenuProps}
                                    >
                                        {RisklevelList?.map((r, i) =>
                                            <MenuItem key={i} value={r?.clientTemplateId} > {r?.risk}</MenuItem>
                                        )}
                                    </Select>

                                </div>
                                <div className='mt-2' >
                                    <span style={{ color: "#3E4A62" }}>  Email Templates  <span style={{ color: "red" }}>*</span></span>
                                    <br />
                                    <Select
                                        sx={{
                                            '& legend': { display: 'none' },
                                            '& fieldset': { top: 0 },
                                            width: "320px"
                                        }}
                                        labelId="demo-multiple-name-label"
                                        id="demo-multiple-name"
                                        size="small"
                                        value={emailId || ""}
                                        onChange={(e) => setEmailId(e.target.value)}
                                        MenuProps={MenuProps}
                                    >
                                        {EmailList?.map((r, i) =>
                                            <MenuItem key={i} title={r?.name} value={r?.emailTemplateID} > {r?.name}</MenuItem>
                                        )}
                                    </Select>

                                </div>
                                <div className='mt-2' >
                                    <span style={{ color: "#3E4A62" }}>  Invitation Type   <span style={{ color: "red" }}>*</span></span>
                                    <br />
                                    <Select
                                        sx={{
                                            '& legend': { display: 'none' },
                                            '& fieldset': { top: 0 },
                                            width: "320px"
                                        }}
                                        labelId="demo-multiple-name-label"
                                        id="demo-multiple-name"
                                        size="small"
                                        value={invitationTypeId || ""}
                                        onChange={(e) => setInvitationTypeId(e.target.value)}
                                        MenuProps={MenuProps}
                                    >

                                        {Invitationlist?.map((r, i) =>
                                            <MenuItem key={i} value={r?.key} > {r?.name}</MenuItem>
                                        )}
                                    </Select>

                                </div>
                            </>}
                            <DialogActions >
                                <div className="login-help__buttonContainer mt-4">
                                    <Button variant="contained" className="login-help-button-cancel mx-2" onClick={CloseTab}>Cancel</Button>
                                    <Button variant="contained" disabled={Dis} className="login-button-request mx-2" onClick={AddorUpdate}>{Tab == 3 ? "Ok" : Tab == 1 ? "Add " : "Save"}</Button>
                                </div>

                            </DialogActions>

                        </div>
                    </DialogActions>

                </DialogContent>
            </Dialog>
            <Card>
                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                        <Stack spacing={2} direction="row">
                            <h3>Invitation Configuration</h3>
                            <div style={{ marginLeft: "Auto", padding: "10px" }}>
                                {HasPermissions(INFO?.AddInvitationTemplates?.actionName, PER?.ScreenPermissions?.Insert) &&
                                    <Button variant="contained" sx={{ padding: "inherit" }} onClick={() => OpenTab(1, "")} >+ Add New</Button>
                                }
                            </div>
                        </Stack >
                    </div>
                </div>
                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />
                <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                    <TextField size='small' placeholder='Search' value={Search} onChange={(e) => FreeSearch(e.target.value)} />
                </div>
                <Box sx={{ backgroundColor: '#f8f9fa' }}>
                    {Count < 1 ?
                        <div hidden={spinner} >
                            <Box border={1} borderLeft={1} borderRight={1} borderColor="#e4e7ec" sx={{ padding: 2, marginTop: 4, marginRight: "12px", width: "auto" }} className="text-center">
                                <span style={{ color: "#667085" }}>No Invitation  found</span>
                            </Box>
                        </div> : <>
                            <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
                                <Table aria-label="customized table">

                                    <TableHead>
                                        <TableRow>
                                            <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Client Name</span></StyledTableCell>
                                            <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Email Template Name</span></StyledTableCell>
                                            <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}>	Questionnaire TemplateName </span></StyledTableCell>
                                            <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Invitation Type</span></StyledTableCell>
                                            <StyledTableCell >&nbsp;</StyledTableCell>
                                            <StyledTableCell >&nbsp;</StyledTableCell>

                                        </TableRow>
                                    </TableHead>
                                    {ClientEmailTemplates?.map((r, i) => (
                                        <TableBody key={i}>

                                            <TableRow key={i}>

                                                <StyledTableCell sx={{ width: "20%" }}>
                                                    {r?.clientName}
                                                </StyledTableCell>

                                                <StyledTableCell sx={{ width: "20%" }}>
                                                    {r?.templateName}
                                                </StyledTableCell>
                                                <StyledTableCell sx={{ width: "20%" }}>
                                                    {r?.qTemplateName}
                                                </StyledTableCell>

                                                <StyledTableCell sx={{ width: "20%" }}>
                                                    {r?.invitationName}
                                                </StyledTableCell>

                                                <StyledTableCell sx={{ width: "5%" }} >
                                                    {HasPermissions(INFO?.AddInvitationTemplates?.actionName, PER?.ScreenPermissions?.Modify) &&
                                                        <IconButton aria-label="edit" onClick={() => OpenTab(2, r)}>
                                                            <img src={Edit} alt="editicon" />
                                                        </IconButton>
                                                    }
                                                </StyledTableCell>

                                                <StyledTableCell sx={{ width: "5%" }}>
                                                    {HasPermissions(INFO?.AddInvitationTemplates?.actionName, PER?.ScreenPermissions?.Delete) &&
                                                        <IconButton aria-label="delete" onClick={() => OpenTab(3, r)} >
                                                            <img src={Trash} alt="trashicon" />
                                                        </IconButton>
                                                    }
                                                </StyledTableCell>

                                            </TableRow>

                                        </TableBody>
                                    ))}
                                </Table>

                            </TableContainer>
                        </>}
                </Box >
            </Card>
            <div hidden={Count < 1}>
                <Paginator
                    count={Math.ceil(Count / 12)}
                    page={Number(number)}
                    margin="18px 0px"
                    onChange={handlePageChange}
                />
            </div>

        </>
    )
}



